import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      user: null,
      selectedProductId: null,
      selectedRoleId: null,
      productDetails: null,
      setAuth: (token, user) => set({ token, user }),
      setProductRole: (productId, roleId, details) => 
        set({ 
          selectedProductId: productId, 
          selectedRoleId: roleId,
          productDetails: details
        }),
      clearProductRole: () => 
        set({ 
          selectedProductId: null, 
          selectedRoleId: null,
          productDetails: null
        }),
      logout: () => set({ 
        token: null, 
        user: null,
        selectedProductId: null,
        selectedRoleId: null,
        productDetails: null
      }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
